module.exports = __webpack_public_path__ + "static/media/new_opportunity.21a9638a.svg";